import React, { forwardRef, RefForwardingComponent } from 'react';

import Cta, { CtaProps } from '@gojob/ui-bits/Cta';

import useTranslation from 'src/translations/useTranslation';

export type SearchButtonProps = CtaProps<'button'>;

const SearchButton: RefForwardingComponent<HTMLButtonElement, SearchButtonProps> = (props, ref) => {
  const t = useTranslation();

  return (
    <Cta color="primary" ref={ref} {...props}>
      {t('find_your_job')}
    </Cta>
  );
};

export default forwardRef(SearchButton);
